import { IVehicle } from "interfaces/session/IVehicle";
import { validateVehicle } from "util/vehicle/validate-vehicle";
import { getModelIconUrl } from "./getModelIconUrl";
import { getRelativeImagePath } from "./getRelativeImagePath";

export const defaultVehicleImageSrc = getRelativeImagePath("/cms/pubicImages/images/default-vehicle-image.png");

export function getDefaultVehicleImage(vehicle: IVehicle | null) {
  if (!validateVehicle(vehicle)) {
    return defaultVehicleImageSrc;
  }

  return getModelIconUrl(vehicle);
}

export default getDefaultVehicleImage;
